var _rect, _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.0157,
    height: 11.4249,
    transform: "translate(0.573975 0.818542)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.49151,
    cy: 4.14596,
    r: 2.89239,
    fill: "#555555"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.697 5.30258L10.697 8.77344",
    stroke: "#555555",
    strokeWidth: 1.73543,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4326 7.03943L8.96175 7.03943",
    stroke: "#555555",
    strokeWidth: 1.73543,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62315 11.3074C9.89019 11.2469 10.0504 10.9693 9.932 10.7224C9.6128 10.0565 9.08818 9.47146 8.40821 9.03048C7.57147 8.48783 6.54627 8.1937 5.49159 8.1937C4.43691 8.19369 3.4117 8.48783 2.57497 9.03048C1.895 9.47146 1.37038 10.0565 1.05117 10.7224C0.932811 10.9693 1.09298 11.2469 1.36002 11.3074V11.3074C4.07996 11.9233 6.90321 11.9233 9.62315 11.3074V11.3074Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.19bd3fa239a250b590c668643e0184af.svg";
export { ForwardRef as ReactComponent };